import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule, MatSelectModule } from '@angular/material';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../../shared/shared.module';

import { CassAccountsPageRoutingModule } from './cass-accounts-page-routing.module';
import { CassAccountWarningsCellComponent } from './cass-accounts-pg/cass-account-warnings-cell.component';
import { CassAccountWarningsDialogComponent } from './cass-accounts-pg/cass-account-warnings-dialog.component';
import { CassAccountRegenerateCellComponent } from './cass-accounts-pg/cass-account-regenerate-cell.component';
import { CassAccountTypeCellComponent } from './cass-accounts-pg/cass-account-type-cell.component';
import { CassAccountTypeChangeDialogComponent } from './cass-accounts-pg/cass-account-type-change-dialog.component';
import { CassAccountsPgComponent } from './cass-accounts-pg/cass-accounts-pg.component';

@NgModule({
  imports: [
    CommonModule,
    CassAccountsPageRoutingModule,
    SharedModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    AgGridModule.withComponents([CassAccountTypeCellComponent, CassAccountRegenerateCellComponent, CassAccountWarningsCellComponent]),
  ],
  declarations: [
    CassAccountsPgComponent,
    CassAccountTypeCellComponent,
    CassAccountRegenerateCellComponent,
    CassAccountWarningsCellComponent,
    CassAccountWarningsDialogComponent,
    CassAccountTypeChangeDialogComponent,
  ],
  entryComponents: [CassAccountTypeChangeDialogComponent, CassAccountWarningsDialogComponent],
})
export class CassAccountsPageModule { }
